import React, { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";

interface ImageCarouselProps {
  images: string[];
  interval?: number;
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ images, interval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, interval);

    return () => resetTimeout();
  }, [currentIndex, images.length, interval]);

  return (
    <div className="w-full relative overflow-visible">
      <div className="relative w-full h-[250px] sm:h-[400px]">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Slide ${index}`}
            className={cn(
              "absolute w-full h-full object-cover transition-opacity duration-700 ease-in-out",
              currentIndex === index ? "opacity-100 z-10" : "opacity-0 z-0"
            )}
          />
        ))}
        <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex gap-1">
          {images.map((_, index) => (
            <span
              key={index}
              className={cn(
                "h-2 w-2 rounded-full transition-all",
                currentIndex === index
                  ? "bg-white/90"
                  : "bg-white/40"
              )}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;
